import { YES_FLAG } from '../shared/constants';
import { ALL_ASSIGNMENTS_CODE } from './constants';

export const normalizeAssignments = (clients = []) => clients.map(({ clientId, assignments }) =>
  assignments.filter(assignment => assignment.assignmentType !== 'USR')
    .map(assignment => ({
      ...assignment,
      assignmentCode: assignment.assignmentCode === 'ALL'
        ? ALL_ASSIGNMENTS_CODE
        : assignment.assignmentCode,
      privileges: assignment.privileges.map(({ privilegeCode }) => privilegeCode),
      clientId,
    })))
  .reduce((checkedAssignments, clientAssignment) => checkedAssignments.concat(clientAssignment), []);

const getCommonAssignments = (assignments1, assignments2) => (
  assignments1.filter(assignment1 => (
    assignments2.find(assignment2 => (
      assignment1.assignmentCode === assignment2.assignmentCode
      && assignment1.assignmentType === assignment2.assignmentType
      && assignment1.clientId === assignment2.clientId
    ))
  ))
);

const getAvailableNormalizedAssignments = (userToEdit, loggedInUser, isSuperUser) => {
  const normalizedAssignmentsForUserToEdit = normalizeAssignments(userToEdit.clients);
  const normalizedAssignmentsForLoggedInUser = normalizeAssignments(loggedInUser ? loggedInUser.clients : []);

  const hasSpecialTypeAll = normalizedAssignmentsForLoggedInUser
    .filter(assignment => assignment.assignmentType === 'AL').length > 0;

  if (isSuperUser || hasSpecialTypeAll) {
    return normalizedAssignmentsForUserToEdit;
  }

  return getCommonAssignments(
    normalizedAssignmentsForUserToEdit,
    normalizedAssignmentsForLoggedInUser
  );
};

export default (userToEdit = null, loggedInUser = null, isSuperUser) => {
  const fields = ({
    email: {
      value: userToEdit && userToEdit.email
        ? userToEdit.email
        : '',
      isValid: !!userToEdit,
    },
    firstName: {
      value: userToEdit && userToEdit.firstName
        ? userToEdit.firstName
        : '',
      isValid: !!userToEdit,
    },
    lastName: {
      value: userToEdit && userToEdit.lastName
        ? userToEdit.lastName
        : '',
      isValid: !!userToEdit,
    },
    sso: {
      value: userToEdit && userToEdit.sso
        ? userToEdit.sso
        : '',
      isValid: !!userToEdit,
    },
    activeFlag: {
      value: userToEdit ? (userToEdit.activeFlag === YES_FLAG) : true,
      isValid: true,
    },

    checkedClients: {
      value: userToEdit && userToEdit.clients
        ? userToEdit.clients.map(({ clientId, name }) => ({ clientId, name }))
        : [],
      isValid: !!userToEdit,
    },

    role: {
      value: userToEdit && userToEdit.clients
        ? userToEdit.clients.map(({ clientId, roleId, roleName }) => ({ clientId, name: roleName, roleId, roleName }))
        : [],
      isValid: !!userToEdit,
    },
    permissions: {
      value: userToEdit && userToEdit.clients
        ? userToEdit.clients.map(({ clientId, userPermissions }) => ({
          clientId,
          permissions: userPermissions.length
            ? userPermissions.map(({ privilegeCode }) => privilegeCode)
            : [],
        }))
        : [],
      isValid: true,
    },
    checkedAssignments: {
      value: userToEdit && userToEdit.clients
        ? getAvailableNormalizedAssignments(userToEdit, loggedInUser, isSuperUser)
        : [],
      isValid: true,
    },

    expirationDate: {
      value: userToEdit && userToEdit.clients
        ? userToEdit.clients.map(({ clientId, expirationDate }) => ({ clientId, expirationDate }))
        : [],
      isValid: true,
    },
  });

  return {
    formData: {
      ...fields,
    },

    selectedClientRoleAssignments: {},
    isFormValid: !!userToEdit,
    triedToSubmitForm: false,
    elementsToValidate: [],
    shouldResetValues: false,
    isRoleValid: !!userToEdit,
    roleErrorMessage: null,
    isExpirationDateValid: !!userToEdit,
    expirationDateErrorMessage: null,
    globalElementsToValidate: ['isRoleValid', 'isExpirationDateValid'],
    isSaveDialogVisible: false,
    isUserEmailUnderDomain: true,
  };
};
